import React from 'react';
import {SORT_DESC, ariaSortOf} from '../../utils/sortRows';
import './SortableTh.scss';

/**
 * Un encabezado de tabla que ordena a pedido (card Ni3pOCBx). El `<th>` lleva `aria-sort` y adentro
 * va un `<button>`: así se ordena con el teclado y un lector de pantalla anuncia en qué orden está.
 *
 * El estado vive en quien dibuja la tabla (`{column, direction}`, ver `utils/sortRows.js`): este
 * componente sólo lo muestra y avisa el clic con `onSort(column, firstDirection)`.
 *
 * La flecha es texto y no un ícono: «▼» / «▲» con la columna activa, y una «↕» tenue en las demás,
 * que es lo que dice que el encabezado se puede tocar.
 */
export function SortableTh({label, column, sort, onSort, firstDirection = SORT_DESC, className = ''}) {
    const ariaSort = ariaSortOf(sort, column);
    const active = ariaSort !== 'none';
    const arrow = ariaSort === 'ascending' ? '▲' : ariaSort === 'descending' ? '▼' : '↕';
    return (
        <th className={className} aria-sort={ariaSort}>
            <button type="button" className={`sort-th${active ? ' -active' : ''}`}
                    onClick={() => onSort(column, firstDirection)}>
                <span className="sort-th__label">{label}</span>
                <span className="sort-th__arrow" aria-hidden="true">{arrow}</span>
            </button>
        </th>
    );
}

export default SortableTh;
